(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["related-articles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      const container = document.querySelector('.related-posts-container');
      const btnLeft = document.querySelector('.nav-btn.left');
      const btnRight = document.querySelector('.nav-btn.right');
      const nav = document.getElementById('related-posts-nav');
      const cards = container.querySelectorAll('.related-post-card');
      const header = document.querySelector('.related-posts-header'); 

      if (cards.length > 0 && cards.length < 3) {
        container.classList.add('centered');
        header.classList.add('centered');
      }
  
      const scrollAmount = 320;
  
      btnLeft.addEventListener('click', () => {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
  
      btnRight.addEventListener('click', () => {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });
  } catch(e) { console.error(e); }
})();

})();
